module.exports = __webpack_public_path__ + "static/ftrs-share-logo-7fcb8b01211ff23d7610e54027a23d34.png";